module.exports = __webpack_public_path__ + "static/media/Workflow activities.bcaf9943.svg";